import styled from 'styled-components';
import {NavLink} from 'react-router-dom';
import {Modal} from 'react-bootstrap';

export const AccountDiv = styled.div`
  .account-body {
    padding-bottom: 40px;
  }

  .__react_component_tooltip {
    width: auto;
    max-width: 239px;
    font-size: 12px;
    color: #2e3038;
    letter-spacing: -0.13px;
    line-height: 14px;
    text-align: center;
    background-color: #f5f499;
    border-radius: 8px;
    padding: 13px 15px;
  }

  .__react_component_tooltip.place-top::before {
    border-top-color: #f5f499;
  }

  .__react_component_tooltip.place-top::after {
    border-top-color: #f5f499;
  }

  @media screen and (min-width: 768px) {
    padding-top: 54px;
  }

  @media (min-width: 768px) and (max-width: 1200px) {
    padding-left: 76px;
  }
`;

export const AccountHeader = styled.div`
  background: ${({theme}) => (theme.name === 'light' ? '#F9F9F9' : '#252730')};
  box-shadow: ${({theme}) => {
    const color = theme.name === 'light' ? '#DCDEE1' : '#4E505A';
    return `inset 0 -1px 0 0 ${color}`;
  }};
  button {
    box-sizing: border-box;
    padding: 0.3em 0.6em;
    border: ${({theme}) => {
      const color = theme.name === 'light' ? '#B8BBBE' : '#4e505a';
      return `1px solid ${color}`;
    }};
    border-radius: 4px;
    background-color: ${({theme}) => (theme.name === 'light' ? '#EDEDED' : '#2e3038')};
    color: ${({theme}) => (theme.name === 'light' ? '#4E505A' : '#ffffff')};
    font-size: 15px;
    font-weight: 600;
    letter-spacing: -0.1px;
    line-height: 22px;
  }
  .profile-image {
    background-color: #0677d8;
    color: #ffffff;
    border-radius: 50%;
    height: 72px;
    width: 72px;
    font-size: 32px;
  }
  .inviteAColleague {
    color: #fff;
    &hover {
      cursor: pointer;
    }
  }
`;

export const CancelSubscription = styled.a`
  margin-bottom: 40px;
`;

export const ProfileTab = styled.nav`
  background-color: ${({theme}) => (theme.name === 'light' ? '#f9f9f9' : '#252730')};
  box-shadow: ${({theme}) => {
    const color = theme.name === 'light' ? '#DCDEE1' : '#4E505A';
    return `inset 0 -1px 0 0 ${color}`;
  }};
`;

export const NavItem = styled.li`
  width: auto !important;
`;

export const Link = styled(NavLink)`
  color: ${({theme}) => (theme.name === 'light' ? '#4E505A' : '#DCDEE1')};
  font-size: 17px;
  letter-spacing: -0.17px;
  line-height: 20px;
  text-align: center;
  padding: 1em 0.5em;
  &.active {
    font-weight: bold;
    border-bottom: 4px var(--primary) solid;
  }
`;

export const WidgetContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  border-radius: 8px;
  padding-bottom: 2.5rem;
  padding-top: 1.5rem;
  background: ${({theme}) => (theme.name === 'light' ? '#EDEDED' : '#252730')};

  .icon {
    height: 48px;
    width: 48px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: 85px;
    padding: auto;
  }
  .icon-green .nav-link {
    padding-bottom: 5px;
  }
  .icon-pink {
    background: #e04463;
  }
  .icon-blue {
    background: #35afcb;
  }
  .icon-green {
    background: #35cb95;
  }
  .icon-orange {
    background: #ff6800;
  }
  .stat {
    color: ${({theme}) => (theme.name === 'light' ? '#2e3038' : '#FFFFF')};
    font-size: 18px;
    font-weight: bold;
    letter-spacing: -0.3px;
    line-height: 24px;
  }
  .title {
    color: ${({theme}) => (theme.name === 'light' ? '#4e505a' : '#DCDEE1')};
    letter-spacing: -0.1px;
    line-height: 20px;
  }
  svg {
    color: #fff;
  }
  .icon .fa-cme-1 {
    width: 30px !important;
    height: 30px !important;
  }
`;

export const DashboardContainer = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 1em;
  margin: 1em auto;

  &:after {
    content: '';
    flex: auto;
  }
`;

export const SettingsGroup = styled.div`
  padding: 1em;
  border-radius: 8px;
  background-color: ${({theme}) => (theme.name === 'light' ? '#EDEDED' : '#252730')};

  .settings-group-header {
    display: flex;
    padding: 0 0 1em 0;
    justify-content: space-between;
  }
  .settings-group-header-label {
    font-size: 18px;
    font-weight: bold;
    letter-spacing: -0.3px;
    line-height: 24px;
  }
`;

export const UpdateButton = styled.button`
  border: none;
  background: none;
  color: #30a0ff;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 15px;
`;

export const UpdateModal = styled(Modal)`
  .modal-dialog {
    max-width: 700px;
    margin: 7.75rem auto !important;
  }
  .modal-content {
    border: none !important;
    background-color: ${({theme}) => (theme.name === 'light' ? '#EDEDED' : '#2e3038')};
    border-radius: 8px;

    .modal-header {
      font-size: 18px;
      font-weight: bold;
      letter-spacing: -0.3px;
      line-height: 24px;
      border: none !important;
    }
    .modal-footer {
      border: none !important;
    }
    .close {
      color: ${({theme}) => theme.circle};
    }
  }
  &.paymentInfoModal .modal-dialog {
    max-width: 636px;
  }
  .account-email {
    padding: 1rem 1rem;
  }
  .account-email-header-label {
    font-size: 18px;
    // font-weight: bold;
    letter-spacing: -0.3px;
    line-height: 24px;
  }
`;
export const LabelDiv = styled.div`
  padding: 0.25em 0;
  font-size: 16px;
  font-weight: bold;
  letter-spacing: -0.16px;
  line-height: 20px;
`;

export const ValueDiv = styled.div`
  padding: 0.25em 0;
  color: ${({theme}) => (theme.name === 'light' ? '#4E505A' : '#dcdee1')};
  font-size: 15px;
  letter-spacing: -0.1px;
  line-height: 20px;
  text-overflow: ellipsis;
  overflow: hidden;
`;

export const FieldName = styled.div`
  font-size: 14px;
  letter-spacing: 0;
  line-height: 19px;
  margin: 0.3em 0;
`;

export const ModalInput = styled.input`
  width: 100%;
  height: 40px;
  border: 1px solid #4e505a;
  border-radius: 20px;
  background-color: #eaecf1;

  &:focus {
    outline: none;
  }
`;

export const UpdateLink = styled.a`
  text-decoration: none;
  color: #30a0ff;
  font-size: 13px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 15px;
  cursor: pointer;

  :hover {
    text-decoration: none;
  }
`;

export const SubscriptionStatus = styled.div`
  display: flex;
  align-items: center;

  .a_reactivate {
    height: 32px;
    width: 106px;
    padding: 0;
  }

  .a_skipTrial {
    height: 24px;
    width: 87px;
    padding: 0;
    font-size: 14px;
    font-weight: 500;
    letter-spacing: -0.09px;
    line-height: 16px;
  }
`;

export const SubscriptionUpgradeContainer = styled.div`
  display: flex;
  background-color: transparent;
  padding-top: 20px;

  @media screen and (min-width: 576px) {
    padding-top: 56px;
  }
`;

export const UpgradeModal = styled(Modal)`
  .modal-dialog {
    max-width: 459px !important;
    min-height: 225px !important;
    margin: 7.75rem auto !important;
  }
  .modal-content {
    border: none !important;
    background-color: ${({theme}) => (theme.name === 'light' ? '#EDEDED' : '#2e3038')};
    border-radius: 8px;

    .a_upgradeModalContent {
      color: #ffffff;
      font-size: 12px;
      letter-spacing: -0.2px;
      line-height: 24px;
      margin-bottom: 37px;
      .a_upgradePlanEmail {
        color: #0677d8;
      }
    }
    .modal-header {
      font-size: 18px;
      font-weight: bold;
      letter-spacing: -0.3px;
      line-height: 24px;
      border: none !important;
    }
    .modal-body {
      padding-top: 14px;
      padding-bottom: 22px;
    }
    .modal-footer {
      border: none !important;
    }
    .a_closeUpgradeInfoButton {
      width: 73px;
      height: 48px;
    }
  }
  &.paymentInfoModal .modal-dialog {
    max-width: 636px;
  }
`;
